<div class="gc-integration-panel bc-panel">
  <div class="gc-panel-header bc-panel-header">
    <div class="bc-panel-header-text">
      <svg-icon [icon]="integration.svgIconName" class="bc-panel-header-icon"></svg-icon>
      <span class="header-text gc-text-bold">{{ integration.tooltip | translate }}</span>
    </div>
  </div>

  <div class="gc-integration-panel-body">
    <app-genesys-iframe
      [iframeUrl]="integrationUrl"
      [title]="integration.title | translate">
    </app-genesys-iframe>
  </div>
</div>

